import { Component, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';

import { ClientProvider } from '../../providers/client/client';
import { UserProvider } from '../../providers/user/user';
import { UserData } from '../../providers/local/user-data';

import * as _ from 'lodash';

declare var google: any;

@Component({
  selector: 'app-client-map',
  templateUrl: './client-map.component.html',
  styleUrls: ['./client-map.component.css']
})
export class ClientMapComponent implements OnInit {

  @ViewChild('mapCanvas') mapElement: ElementRef;
  map: any;
  operators:any = [];


  markerList: any = [];
  clients: any;
  selectedClients: any = [];
  selectedUserId: any = "";

  constructor(
    public clientWS: ClientProvider,
    public userWS: UserProvider,
    public userData: UserData,
  ) { }

  ngOnInit() {
    this.initializeView();
  }

  openClient(item) {

  }

  addMarker(item) {
    if(this.map && item.latitude) {
      let position = {
        lat: item.latitude,
        lng: item.longitude
      }

      var contentString = '<div id="content">'+
      '<div id="siteNotice">'+
      '</div>'+
      '<h2 id="firstHeading" class="firstHeading">'+item.businessName+'</h2>'+
      '<div id="bodyContent">'+
      '<p>Estatus del credito:<b>'+item.estatus+'</b></p>'+
      '</div>'+
      '</div>';

      var infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      let marker = new google.maps.Marker({
        position: position,
        map: this.map,
        title: item.businessName,
        id: item.customerId,
        assignedToId: item.assignedToId,
        infowindow: infowindow
      });

     

      marker.addListener('click', ()=> {
        console.log('itemID', item.customerId, item.businessName);
        this.map.setZoom(14);
        this.map.setCenter(marker.getPosition());
        /*this.navCtrl.push('ClientCreditsPage', {
          id: item.customerId
        });*/
        this.closeAllInfoWindow()
        .then((data: any) => {
          infowindow.open(this.map, marker);

        });

      });
      this.markerList.push(marker);
    }
  }

  initializeView() {
    this.markerList = [];
    this.initMap()
    .then((res) => {
      return this.userWS.managedByCurrentUser();
    })
    .then((res: any) => {
     if(res.status == 'success') {
        this.operators = res.data;
      }

      
      return this.clientWS.getClientLocations();
      
    })
    .then((res:any) => {
      if(res.status == 'success' && res.data) {
        console.log(res.data);
        this.clients = res.data;
        this.clients.map((item: any) => {
          this.addMarker(item);
        });

      }
    });
  }

  initMap() {

    let mapEle = this.mapElement.nativeElement;

    let position = { 
      "lat": 29.0729673, 
      "lng": -110.95591919999998
    };

    this.map = new google.maps.Map(mapEle, {
      center: position,
      zoom: 6
    });

    /*this.markerList.push(new google.maps.Marker({
      position: position,
      map: this.map,
      title: 'Ubicacion del cliente'
    }));*/

    return Promise.resolve({ status: 'success', data: true});
  }

  filterClients() {
    this.setMapOnAll(null);
    //console.log(this.markerList, this.selectedUserId);
    let filteredMarks = this.markerList;
    if(parseInt(this.selectedUserId) > 0)  {
       filteredMarks = _.filter(this.markerList, { assignedToId: parseInt(this.selectedUserId) });
    }

    for(var i in filteredMarks) {
      filteredMarks[i].setMap(this.map);
    }
  }

  closeAllInfoWindow() {
    return Promise.all(this.markerList.map((item: any) => {
      if(item.infowindow) {
        item.infowindow.close();

      }
    }));
  }
  setMapOnAll(map) {
    for (var i = 0; i < this.markerList.length; i++) {
      this.markerList[i].setMap(map);
    }
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pages/client-map/client-map.component.ts